import { MediaQuery } from '@maxpreps/shared/styles/breakpoint';
import styled from 'styled-components';
import THEME from '../../styles/colors';

export const RightScrollShadow = styled.div.attrs({ className: 'loaded' })`
  position: absolute;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    ${THEME.shadow.medium} 100%
  );
  top: 0;
  right: 0;
  height: 100%;
  width: 25px;
  z-index: 1;

  ${MediaQuery.Tablet} {
    display: none;
  }

  pointer-events: none;
`;

export const LeftScrollShadow = styled(RightScrollShadow)`
  background: linear-gradient(
    90deg,
    ${THEME.shadow.medium} 0%,
    rgba(255, 255, 255, 0) 100%
  ) !important;
  left: 0;
  right: auto;
`;
